import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { usePhoneCapture } from "../context/PhoneCapture";
import { API_BASE } from "../lib/links";
import { openCheckout, PENDING_BOOKING_KEY } from "../lib/booking";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const ensurePhone = usePhoneCapture();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = window.location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    axios
      .post(`${API_BASE}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then(async (res) => {
        window.history.replaceState(null, "", window.location.pathname);
        setUser(res.data);
        // Resume a booking intent captured before the sign-in redirect
        const pendingRaw = sessionStorage.getItem(PENDING_BOOKING_KEY);
        if (pendingRaw) {
          sessionStorage.removeItem(PENDING_BOOKING_KEY);
          let intent = { kind: "call", source: pendingRaw };
          try {
            intent = JSON.parse(pendingRaw);
          } catch {
            // legacy plain-string intent — defaults already set
          }
          navigate("/", { replace: true, state: { user: res.data } });
          const phone = await ensurePhone(res.data);
          if (phone !== null) {
            await openCheckout(
              intent.kind === "seat" ? "seat" : "call",
              intent.source,
              res.data,
              undefined,
              phone || undefined
            );
          }
          return;
        }
        navigate("/", { replace: true, state: { user: res.data } });
      })
      .catch(() => navigate("/", { replace: true }));
  }, [navigate, setUser]);

  return null;
}
